import {Card} from 'react-bootstrap'
import {NodeOne} from '../../../graphql/types/usersTypes'
import {useState} from 'react'
import {AddValidation} from './activityTab/AddValidation'
import {ResumenValidations} from './activityTab/ResumenValidations'
// import {KTIcon} from '../../../../../_metronic/helpers'

interface IActivity {
  user: NodeOne
  refetch: () => void
}

export const ActivityTab: React.FC<IActivity> = ({user, refetch}) => {
  const [addValidation, setAddValidation] = useState(false)
  const onToggleSubTab = (bool?: boolean) => {
    setAddValidation(Boolean(bool))
  }
  return (
    <Card>
      <Card.Header>
        <Card.Title>Validaciones</Card.Title>
        {/* {addValidation ? (
          <div className='card-title'>
            <Button size='sm' variant='info' onClick={() => setAddValidation(false)}>
              Ver validaciones
            </Button>
          </div>
        ) : (
          <div className='card-title'>
            <Button size='sm' onClick={() => setAddValidation(true)}>
              <KTIcon iconName='plus' /> Agregar
            </Button>
          </div>
        )} */}
      </Card.Header>
      <Card.Body>
        {addValidation ? (
          <AddValidation id={user.id} refetch={refetch} onToggleSubTab={onToggleSubTab} />
        ) : (
          <ResumenValidations user={user} refetch={refetch} />
        )}
      </Card.Body>
    </Card>
  )
}
